module.exports = __webpack_public_path__ + "guanao-pc/static/media/about.e1312b2c.jpg";